import React from "react";

import Page from "../../../../components/Page";
import Header from "../../../../components/Header";
import PageHeaderBanner from "../../../../sections/layouts/pageHeaderBanner";
import VideoSection from "../../../../sections/layouts/videoSection";
import Section from "../../../../sections/layouts/section";
import Footer from "../../../../components/Footer";
import Custom_a from "../../../../sections/layouts/custom_a";
import Image from "../../../../components/Image";
import VerticalTickBox from "../../../../sections/layouts/verticalTickBox";

import granadilla_video_image from "../images/vend/video_thumbnail_granadilla.jpg";
import vend_banner from "../images/vend/image_insert_vend.jpg";
import vend_stand from "../images/stand.png";

import nic_harry_avatar from "../images/vend/avatar_nic-harry.png";
import vendBannerLogo from "../images/vend/logo_vend.png";
import YocoMerchant from "../yocoMerchant";
import SEOInfo from "../../../../components/SEOInfo";
import ColumnInfoBox from "../../../../sections/layouts/columnInfoBox";

const headerBannerProps = {
  pageSubheader: "Vend + Yoco",
  textColor: "black",
  bgColor: "#f6f6f6",
  pageText: (
    <p>
      Retail solutions at your fingertips with Yoco Payments and Vend POS
      software. <br />* Currently only available using the new Vend Register
      iPad app.
    </p>
  )
};

const tickBox = [
  "Sell in-store, online and on-the-go",
  "Access and manage your inventory anywhere, anytime - all on the cloud",
  "Track sales, revenue and profit margins and make smarter, more profitable decisions",
  "Scale up by adding products, staff, registers and stores, in just a few clicks"
];

const costInfo = [
  {
    heading: "Automation saves time",
    paragraph:
      "Managing payment reconciliations, cash-ups and more all in one platform."
  },
  {
    heading: `Happy staff & customers`,
    paragraph:
      "Less time spent on tasks means more time to spend on your customers' experience."
  },
  {
    heading: `Less risk of fraud`,
    paragraph:
      "Data from till balances is fed directly to the POS and compared without manual input."
  },
  {
    heading: `Reporting made easy`,
    paragraph:
      "Instant access to your business sales, staff performance and stock levels."
  }
];

const IndexPage = props => {
  const { location } = props;
  return (
    <Page>
      <SEOInfo
        title={"Vend"}
        description={""}
        canonicalLink={location.pathname}
      />
      <Header />
      <PageHeaderBanner pageLogo={vendBannerLogo} {...headerBannerProps} />
      <Section className={"pt-4 pb-0"}>
        <div className={"container"}>
          <div className={"row"}>
            <ColumnInfoBox
              data={costInfo}
              headerStyle={{ fontWeight: "bold" }}
            />
          </div>
        </div>
        <div className={"row"}>
          <div className={"col-12 pt-4"}>
            <img src={vend_banner} alt={"could not load image"} />
          </div>
        </div>
      </Section>
      <Section textAlign="left">
        <div className={"container"}>
          <div className={"row"}>
            <div className={"col-md-7"}>
              <h2>PARTNER FEATURES</h2>
              <h3 className={"pr-0"}>
                Vend is one of the leading point of sale software for retailers.
              </h3>
              <VerticalTickBox
                data={tickBox}
                tickStyle={{ marginTop: "35px", marginLeft: "7px" }}
              />
            </div>
            <div className={"col-md-5 pl-md-5"}>
              <Image src={vend_stand} />
            </div>
          </div>
        </div>
      </Section>
      <Section
        header="YOCO + VEND INTEGRATION"
        subHeader="What our merchants are saying."
        bgColor="#F6F6F6"
      >
        <div className={"container"}>
          <div className={"row"}>
            <YocoMerchant />
            <YocoMerchant
              avatar={nic_harry_avatar}
              paragraph={
                "Working with Yoco through our Vend point of sale is simple and extremely efficient. Switching apps as we've had to do in the past wasn't a sustainable way to complete transactions. Now with the Yoco/Vend integration the customer checkout process is seamless."
              }
              merchantName={"NIC HARRY"}
            />
          </div>
        </div>
      </Section>
      <VideoSection
        header={["TESTIMONIAL VIDEO"]}
        subHeader={["Granadilla Swimwear uses Yoco + Vend"]}
        paragraph={[
          "Icing brownie halvah pastry souffle oat cake desert. Tootsie roll candy canes cake. Toffee tiramisu marshmallow pie"
        ]}
        youtubeVideoId="MhjTJUqogjg"
        previewImage={granadilla_video_image}
        bgColor="#FFFFFF"
      />
      <Section bgColor="#DEE6E9">
        <Custom_a />
      </Section>

      <Footer />
    </Page>
  );
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/za/integrations/vend/index.js